<div class="voices-top-section">
    <div class="app-l-container">
        <div class="app-l-page__navigation">
            <div class="app-l-page__previous" (click)="goBack()">
                <button
                    aria-label="Go to previous page"
                    class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                    <svg-icon icon="arrowLeft" class="w-100 h-100"></svg-icon>
                </button>
            </div>
            <nav class="app-l-page__breadcrumbs" aria-label="Breadcrumb">
                <ul class="breadcrumbs-list">
                    <li class="breadcrumbs-list-item">
                        <a
                            translate
                            [routerLink]="['/app/series']"
                            tabindex="0"
                            aria-label="Go to series page: series.title">
                            series.title
                        </a>
                    </li>
                    <li
                        class="breadcrumbs-list-item app-l-current-page"
                        translate
                        aria-current="page">
                        series.seriesTypes.audio
                    </li>
                </ul>
            </nav>
        </div>
        <div class="app-l-voices-banner">
            <div class="app-l-voices-banner__left">
                <h1 class="app-l-voices-banner__heading" translate>
                    series.seriesTypes.audio
                </h1>
                <!-- <h6 class="app-l-voices-banner__desc" translate>
                    Lorem ipsum dolor sit amet consectetur. Tortor sit vel.
                </h6> -->
            </div>
        </div>
    </div>
</div>
<div class="voice-series-main-container">
    <div class="series-type-section">
        <div class="series-type-list">
            <button
                class="series-type-card stories"
                *ngIf="enableStorySeries"
                (click)="goToVoiceSeries('stories')">
                <div class="cover-image-section">
                    <img [src]="'../../../assets/img/series/storiesBg.svg'" />
                </div>
                <div class="card-content" translate>
                    series.voiceSeries.stories
                </div>
            </button>
            <button
                class="series-type-card burning_questions"
                *ngIf="enableBurningQuestionSeries"
                (click)="goToVoiceSeries('burningQuestions')">
                <div class="cover-image-section">
                    <img [src]="'../../../assets/img/series/voiceBg.svg'" />
                </div>
                <div class="card-content" translate>
                    series.voiceSeries.burningQuestions
                </div>
            </button>
        </div>
    </div>
</div>
